<template>
  <div>
    <b-breadcrumb class="breadcrumb">
      <b-breadcrumb-item href="/">
        <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
        首页
      </b-breadcrumb-item>
      <b-breadcrumb-item active>招聘会</b-breadcrumb-item>
    </b-breadcrumb>

    <b-card no-body>
      <div class="d-flex flex-row align-items-center">
        <b-form-input v-model="meetName" type="search" size="sm" placeholder="请输入招聘会名称"></b-form-input>
        <b-form-datepicker id="dpBeginDate" v-model="meetBeginDate" placeholder="请选择招聘会开始日期" local="zh" v-bind="localSetting" :start-weekday="1" size="sm" class="ml-1"></b-form-datepicker>
        <b-form-datepicker id="dpEndDate" v-model="meetEndDate" placeholder="请选择招聘会结束日期" local="zh" v-bind="localSetting" :start-weekday="1" size="sm" class="ml-1"></b-form-datepicker>
        <b-button variant="success" size="sm" block class="button-size ml-1" @click="searchData">检索数据</b-button>
      </div>
    </b-card>

    <b-row class="mt-2">
      <b-col>
        <b-card header="当前招聘会" body-bg-variant="light" body-class="meet-list-body">
          <b-card-body class="mb-2 meet-body" v-for="(item, index) in meetList" :key="index">
            <b-row class="bg-white pl-2 pb-2">
              <b-col class="date-bg">
                <div class="left-div">
                  <p class="nianyue">{{ item.beginTime | yearMonthFilter }}</p>
                  <p class="number">{{ item.beginTime | dayFilter }}</p>
                  <p class="week">{{ item.beginTime | timeFilter(item.endTime) }}</p>
                </div>
              </b-col>
              <b-col cols="10">
                <div class="meet-title">
                  <b-link :to="'/show-meet/' + item.jobFairId" target="_blank">{{ item.jobFairName }}</b-link>
                </div>
                <div class="content-font"><span class="font-weight-bold">报名时间：</span>{{ item.enrollBeginTime }} ~ {{ item.enrollEndTime }}</div>
                <div class="content-font"><span class="font-weight-bold">召开时间：</span>{{ item.beginTime }} ~ {{ item.endTime }}</div>
                <div class="content-font">
                  <span class="font-weight-bold">主办单位：</span>{{ item.organizer }} <span class="font-weight-bold">|</span> <span class="font-weight-bold">承办单位：</span>{{ item.exhibitor }}
                </div>
                <div class="content-font">
                  <span class="font-weight-bold">协办单位：</span>{{ item.coorganizer }} <span class="font-weight-bold">|</span> <span class="font-weight-bold">支持单位：</span>{{ item.supportUnit }}
                </div>
                <div class="content-font"><span class="font-weight-bold">地址：</span>{{ item.addr }}</div>
              </b-col>
            </b-row>
          </b-card-body>

          <div class="d-flex flex-row justify-content-center font-14">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" class="mt-4" v-if="rows > 0">
              <template v-slot:first-text><span class="text-success">首页</span></template>
              <template v-slot:prev-text><span class="text-danger">前页</span></template>
              <template v-slot:next-text><span class="text-warning">后页</span></template>
              <template v-slot:last-text><span class="text-info">尾页</span></template>
              <template v-slot:ellipsis-text>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
              </template>
              <template v-slot:page="{page, active}">
                <b v-if="active">{{ page }}</b>
                <i v-else>{{ page }}</i>
              </template>
            </b-pagination>
            <div v-else class="mt-4">尚无数据</div>
          </div>
        </b-card>

        <b-card header="往期招聘会" body-bg-variant="light" body-class="meet-list-body" class="mt-2">
          <b-card-body class="mb-2 meet-body" v-for="(item, index) in expireMeetList" :key="index">
            <b-row class="bg-white pl-2 pb-2">
              <b-col class="date-bg">
                <div class="left-div">
                  <p class="nianyue">{{ item.beginTime | yearMonthFilter }}</p>
                  <p class="number">{{ item.beginTime | dayFilter }}</p>
                  <p class="week">{{ item.beginTime | timeFilter(item.endTime) }}</p>
                </div>
              </b-col>
              <b-col cols="10">
                <div class="meet-title">
                  <b-link :to="'/show-meet/' + item.jobFairId" target="_blank">{{ item.jobFairName }}</b-link>
                </div>
                <div class="content-font"><span class="font-weight-bold">报名时间：</span>{{ item.enrollBeginTime }} ~ {{ item.enrollEndTime }}</div>
                <div class="content-font"><span class="font-weight-bold">召开时间：</span>{{ item.beginTime }} ~ {{ item.endTime }}</div>
                <div class="content-font">
                  <span class="font-weight-bold">主办单位：</span>{{ item.organizer }} <span class="font-weight-bold">|</span> <span class="font-weight-bold">承办单位：</span>{{ item.exhibitor }}
                </div>
                <div class="content-font">
                  <span class="font-weight-bold">协办单位：</span>{{ item.coorganizer }} <span class="font-weight-bold">|</span> <span class="font-weight-bold">支持单位：</span>{{ item.supportUnit }}
                </div>
                <div class="content-font"><span class="font-weight-bold">地址：</span>{{ item.addr }}</div>
              </b-col>
            </b-row>
          </b-card-body>

          <div class="d-flex flex-row justify-content-center font-14">
            <b-pagination v-model="expireCurrentPage" :total-rows="expireRows" :per-page="expirePerPage" class="mt-4" v-if="expireRows > 0">
              <template v-slot:first-text><span class="text-success">首页</span></template>
              <template v-slot:prev-text><span class="text-danger">前页</span></template>
              <template v-slot:next-text><span class="text-warning">后页</span></template>
              <template v-slot:last-text><span class="text-info">尾页</span></template>
              <template v-slot:ellipsis-text>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
              </template>
              <template v-slot:page="{page, active}">
                <b v-if="active">{{ page }}</b>
                <i v-else>{{ page }}</i>
              </template>
            </b-pagination>

            <div v-else class="mt-4">尚无数据</div>
          </div>
        </b-card>
      </b-col>
      <b-col cols="3" class="right-card-left">
        <b-card header="关注公众号">
          <b-img :src="jyhQrcode" alt="Image 1" width="240" height="240"></b-img>
          <div class="job-prop">扫一扫上面的二维码，关注就业汇公众号，访问更加方便。</div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import JyhQrcode from '@/assets/jyh-qrcode.jpg'

export default {
  name: 'Metting',
  filters: {
    yearMonthFilter(val) {
      if (!(val instanceof Date)) {
        try {
          val = new Date(val)
        } catch (e) {
          console.error(e)
        }
      }

      const year = val.getFullYear()
      const month = val.getMonth()
      let m = month + 1
      if (m < 10) {
        m = '0' + m
      }

      return year + '年' + m + '月'
    },
    dayFilter(val) {
      if (!(val instanceof Date)) {
        try {
          val = new Date(val)
        } catch (e) {
          console.error(e)
        }
      }

      let day = val.getDate()
      if (day < 10) {
        day = '0' + day
      }

      return day
    },
    hourMinuteFilter(val) {
      if (!(val instanceof Date)) {
        try {
          val = new Date(val)
        } catch (e) {
          console.error(e)
        }
      }

      let hour = val.getHours()
      if (hour < 10) {
        hour = '0' + hour
      }

      let minute = val.getMinutes()
      if (minute < 10) {
        minute = '0' + minute
      }

      return hour + ':' + minute
    },
    timeFilter(val1, val2) {
      if (!(val1 instanceof Date)) {
        try {
          val1 = new Date(val1)
        } catch (e) {
          console.error(e)
        }
      }
      if (!(val2 instanceof Date)) {
        try {
          val2 = new Date(val2)
        } catch (e) {
          console.error(e)
        }
      }

      const day1 = val1.getDate()
      const day2 = val2.getDate()
      let sameDate = false
      if (day1 === day2) {
        sameDate = true
      }

      let hour1 = val1.getHours()
      if (hour1 < 10) {
        hour1 = '0' + hour1
      }
      let hour2 = val2.getHours()
      if (hour2 < 10) {
        hour2 = '0' + hour2
      }

      let minute1 = val1.getMinutes()
      if (minute1 < 10) {
        minute1 = '0' + minute1
      }
      let minute2 = val2.getMinutes()
      if (minute2 < 10) {
        minute2 = '0' + minute2
      }

      let rtn = ''
      if (sameDate) {
        rtn = hour1 + ':' + minute1 + '~' + hour2 + ':' + minute2
      } else {
        rtn = hour1 + ':' + minute1 + '~' + '(' + day2 + ')' + hour2 + ':' + minute2
      }
      return rtn
    }
  },
  data() {
    return {
      // 就业汇公众号二维码
      jyhQrcode: JyhQrcode,
      meetName: null,
      meetBeginDate: null,
      meetEndDate: null,
      meetList: [],
      expireMeetList: [],
      localSetting: {
        labelPrevYear: '上一年',
        labelPrevMonth: '上个月',
        labelCurrentMonth: '当前月份',
        labelNextMonth: '下个月',
        labelNextYear: '明年',
        labelToday: '今天',
        labelSelected: '选定日期',
        labelNoDateSelected: '未选择日期',
        labelCalendar: '日历',
        labelNav: '日历导航',
        labelHelp: '使用光标键浏览日期'
      },
      // 当前分页
      rows: 100,
      perPage: 62,
      currentPage: 1,
      // 往期分页
      expireRows: 100,
      expirePerPage: 62,
      expireCurrentPage: 1
    }
  },
  created() {},
  mounted() {
    this.searchData()
  },
  methods: {
    searchData() {
      this.fetchActiveMeetList()
      this.fetchExpireMeetList()
    },
    /**
     * 获取有效的招聘会列表
     */
    fetchActiveMeetList() {
      const that = this
      const postData = {
        pageNo: that.currentPage,
        pageSize: that.perPage,
        meetName: that.meetName,
        beginDate: that.meetBeginDate,
        endDate: that.meetEndDate
      }
      that
        .$http({
          method: 'post',
          url: '/portal/active-meet-list',
          data: postData
        })
        .then((d) => {
          that.rows = d.total
          that.meetList = d.records
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取有效的招聘会列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    },
    /**
     * 获取往期的招聘会列表
     */
    fetchExpireMeetList() {
      const that = this
      const postData = {
        pageNo: that.currentPage,
        pageSize: that.perPage,
        meetName: that.meetName,
        beginDate: that.meetBeginDate,
        endDate: that.meetEndDate
      }
      that
        .$http({
          method: 'post',
          url: '/portal/expire-meet-list',
          data: postData
        })
        .then((d) => {
          that.expireRows = d.total
          that.expireMeetList = d.records
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取往期的招聘会列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.font-14 {
  font-size: 14px;
}
// 设置过滤区域样式
.button-size {
  width: 214px;
}
// 设置输入框、下拉选择框、按钮的字体大小
.form-control-sm {
  font-size: 14px;
}
.custom-select-sm {
  font-size: 14px;
}
.btn-sm,
.btn-group-sm > .btn {
  font-size: 14px;
}

.date-bg {
  background: url(~@/assets/date_bg.jpg) no-repeat;
  padding-left: 0px;
  padding-right: 0px;

  .left-div {
    width: 134px;
    height: 181px;
  }

  .nianyue {
    padding-bottom: 0px;
    padding-left: 20px;
    padding-right: 0px;
    color: #fff;
    font-size: 16px;
    padding-top: 36px;
    margin-bottom: 0px;
  }

  .number {
    text-align: center;
    color: #333;
    font-size: 56px;
    font-weight: 700;
    margin-bottom: 10px;
  }

  .week {
    padding-bottom: 0px;
    text-align: center;
    padding-right: 0px;
    color: #333;
    font-size: 16px;
    margin-top: -10px;
  }
}

.right-card-left {
  padding-left: 0px;
}

.meet-list-body {
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 0px;
}

.meet-body {
  padding-left: 16px;
  padding-top: 0px;
  padding-right: 16px;
  padding-bottom: 0px;
}

.meet-title {
  padding-top: 10px;
  font-size: 22px;
  font-weight: bolder;
  color: red;
}

.job-prop {
  font-size: 14px;
}
</style>
